import isEqual from 'lodash-es/isEqual'

export function getUserLabel(option) {
  return option.fullname || option?.label?.fullname
}

export function getValue(option) {
  return option.value || option.id
}

export function isFormCommentsFieldsEqual({ initialValues, values }) {
  return (
    (isEqual(initialValues.template, values.template) &&
      isEqual(initialValues.comment, values.comment)) ||
    (values.isComment && !values.comment && !values.template)
  )
}
